module.exports = __webpack_public_path__ + "img/logga_upplevelser.ca8af55c.svg";